module.exports = __webpack_public_path__ + "static/media/icon-call-grey.e9187f77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-call-grey.svg
// module id = 928
// module chunks = 0